import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import defaultLayoutImage from '@assets/images/letterPaperLayout/defaultLayout.png'
import defaultLayoutBorder from '@assets/images/letterPaperLayout/layoutBorder1.png'
import defaultLayoutBorder2 from '@assets/images/letterPaperLayout/layoutBorder2.png'
import defaultLayoutInfoBlock from '@assets/images/letterPaperLayout/layoutInfoBlock1.png'
import defaultLayoutInfoBlock2 from '@assets/images/letterPaperLayout/layoutInfoBlock2.png'
import defaultLayoutEnglish from '@assets/images/letterPaperLayout/defaultLayoutEnglish.png'
import defaultLayoutPageBreak from '@assets/images/letterPaperLayout/layoutPageBreak.png'
import letterPaperLayoutTypesEnum from '@/enums/letter-paper-layout-types.enum'

function LetterPaperLayoutThumbnail(props) {

  const {
    DOCUMENT_MAIN,
    DOCUMENT_MAIN_BORDER,
    DOCUMENT_MAIN_BORDER2,
    DOCUMENT_INFO_BLOCK,
    DOCUMENT_INFO_BLOCK2,
    DOCUMENT_MAIN_ENGLISH,
    DOCUMENT_MAIN_PAGEBREAK,
  } = letterPaperLayoutTypesEnum

  const classes = useStyles(props)
  const { thumbnailItems, className, letterPaperLayoutId } = props

  const thumbnailNames = thumbnailItems?.filter(({ id }) => id === letterPaperLayoutId).map(items => items.name).toString()

  let src
  switch (thumbnailNames) {
    case DOCUMENT_MAIN:
      src = defaultLayoutImage
      break
    case DOCUMENT_MAIN_PAGEBREAK:
      src = defaultLayoutPageBreak
      break
    case DOCUMENT_MAIN_BORDER:
      src = defaultLayoutBorder
      break
    case DOCUMENT_MAIN_BORDER2:
      src = defaultLayoutBorder2
      break
    case DOCUMENT_INFO_BLOCK:
      src = defaultLayoutInfoBlock
      break
    case DOCUMENT_INFO_BLOCK2:
      src = defaultLayoutInfoBlock2
      break
    case DOCUMENT_MAIN_ENGLISH:
      src = defaultLayoutEnglish
      break
    default:
      src = defaultLayoutImage
      break
  }

  return (
    <div className={clsx(classes.container, className)}>
      <img className={classes.img} src={src} />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    height: (props) => props.height,
  },
  img: {
    width: 282,
    height: 400,
    boxShadow: `3px 3px 5px 5px ${theme.midGrey}`,
    marginRight: 0,
    marginLeft: 'auto',
  },
}))

LetterPaperLayoutThumbnail.propTypes = {
  height: PropTypes.any,
  className: PropTypes.string,
  thumbnailItems: PropTypes.object,
  letterPaperLayoutId: PropTypes.string,
}

LetterPaperLayoutThumbnail.defaultProps = {
  className: undefined,
  height: 400,
}

export default React.memo(LetterPaperLayoutThumbnail)
